import {
  ApiGetRequest,
  ApiPostRequest,
  ApiPutRequest,
  ApiDeleteRequest,
} from '../../../api';
// import { _ } from 'vue-underscore';
import { showNotif } from '../../notification';
import moment from 'moment-mini';

export const state = {
  data: {
    title: 'Saldo Awal Hutang',
    title_form: 'Form Saldo Awal Hutang',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/fin',
      },
      {
        text: 'Saldo Awal',
        href: '/adm/fin/setting/saldo-awal',
        active: true,
      },
    ],
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_customer',
    sortDesc: true,
    fields: [
      {
        key: 'principle',
        label: 'Nama Pelanggan',
        sortable: true,
      },
      {
        key: 'date_hutang',
        label: 'Tanggal',
        sortable: true,
      },
      {
        key: 'no_invoice',
        label: 'Invoice',
      },
      {
        key: 'code_currency',
        label: 'Currency',
      },
      {
        key: 'nominal_hutang',
        label: 'Saldo Hutang',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    form: {
      id_principle: '',
      principle_code: '',
      principle_name: '',
    },
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
};

export const mutations = {
  settingSaldoHutang(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async getListSaldoHutang({ commit, state }) {
    commit('settingSaldoHutang', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
    };

    let result = await ApiGetRequest(`fin/saldo-hutang`, params);
    commit('settingSaldoHutang', {
      loading: false,
    });

    if (!result.error) {
      commit('settingSaldoHutang', {
        items: result.data.object || [],
        total: result.data.total || 0,
      });

      return true;
    }

    return false;
  },

  async getDetailSaldoHutang({ commit, state }, payload = null) {
    commit('settingSaldoHutang', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`fin/saldo-hutang/${payload.id}`);
    commit('settingSaldoHutang', {
      loading: false,
    });

    if (!result.error) {
      commit('settingSaldoHutang', {
        form: {
          ...data.form,
          ...result.data.object,
          date_hutang: result.data.object.date_hutang
            ? moment(result.data.object.date_hutang).format('DD/MM/YYYY')
            : '',
        },
      });

      return true;
    }

    return false;
  },

  async createSaldoHutang({ commit, state, dispatch }) {
    commit('settingSaldoHutang', {
      loading: true,
    });

    let result = await ApiPostRequest(`fin/saldo-hutang`, state.data.form);
    commit('settingSaldoHutang', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updateSaldoHutang({ commit, state, dispatch }, payload = null) {
    commit('settingSaldoHutang', {
      loading: true,
    });

    let result = await ApiPutRequest(
      `fin/saldo-hutang/${payload.id}`,
      state.data.form
    );

    commit('settingSaldoHutang', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async deleteSaldoHutang({ commit, dispatch }, payload = null) {
    commit('settingSaldoHutang', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`fin/saldo-hutang/${payload.id}`);
    commit('settingSaldoHutang', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },
};
